// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageDesignNotePaneQueryVariables = Types.Exact<{
  designPackageVersionId: Types.Scalars['ID']['input'];
  placeholderId: Types.Scalars['ID']['input'];
}>;


export type DesignPackageDesignNotePaneQuery = { __typename?: 'Query', takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string, designNotes: Array<{ __typename?: 'ReadyPlanDesignNote', id: string, content: string, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }>, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> }> } };

export type DesignPackageDesignNotePane_MetadataQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  designPackageVersionId: Types.Scalars['ID']['input'];
  targetGroupIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type DesignPackageDesignNotePane_MetadataQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, availableTargetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string }>, combinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }> } };

export type SaveReadyPlanDesignNoteMutationVariables = Types.Exact<{
  input: Types.SaveReadyPlanDesignNoteInput;
}>;


export type SaveReadyPlanDesignNoteMutation = { __typename?: 'Mutation', saveReadyPlanDesignNote: { __typename?: 'SaveReadyPlanDesignNoteResult', readyPlanDesignNote: { __typename?: 'ReadyPlanDesignNote', id: string, content: string, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }>, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> } } };

export type DesignPackageDesignNotePane_TakeoffLineItemFragment = { __typename?: 'TakeoffLineItem', id: string, designNotes: Array<{ __typename?: 'ReadyPlanDesignNote', id: string, content: string, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }>, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> }> };

export type DesignPackageDesignNotePane_ReadyPlanDesignNoteFragment = { __typename?: 'ReadyPlanDesignNote', id: string, content: string, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }>, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string }> };

export const DesignPackageDesignNotePane_ReadyPlanDesignNoteFragmentDoc = gql`
    fragment DesignPackageDesignNotePane_ReadyPlanDesignNote on ReadyPlanDesignNote {
  id
  content
  targetCombinations {
    id
    name
  }
  targetGroups {
    id
  }
}
    `;
export const DesignPackageDesignNotePane_TakeoffLineItemFragmentDoc = gql`
    fragment DesignPackageDesignNotePane_TakeoffLineItem on TakeoffLineItem {
  id
  designNotes {
    ...DesignPackageDesignNotePane_ReadyPlanDesignNote
  }
}
    ${DesignPackageDesignNotePane_ReadyPlanDesignNoteFragmentDoc}`;
export const DesignPackageDesignNotePaneDocument = gql`
    query DesignPackageDesignNotePane($designPackageVersionId: ID!, $placeholderId: ID!) {
  takeoffLineItem(id: $placeholderId, versionId: $designPackageVersionId) {
    ...DesignPackageDesignNotePane_TakeoffLineItem
  }
}
    ${DesignPackageDesignNotePane_TakeoffLineItemFragmentDoc}`;

/**
 * __useDesignPackageDesignNotePaneQuery__
 *
 * To run a query within a React component, call `useDesignPackageDesignNotePaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageDesignNotePaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageDesignNotePaneQuery({
 *   variables: {
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *      placeholderId: // value for 'placeholderId'
 *   },
 * });
 */
export function useDesignPackageDesignNotePaneQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables> & ({ variables: DesignPackageDesignNotePaneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables>(DesignPackageDesignNotePaneDocument, options);
      }
export function useDesignPackageDesignNotePaneLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables>(DesignPackageDesignNotePaneDocument, options);
        }
export function useDesignPackageDesignNotePaneSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables>(DesignPackageDesignNotePaneDocument, options);
        }
export type DesignPackageDesignNotePaneQueryHookResult = ReturnType<typeof useDesignPackageDesignNotePaneQuery>;
export type DesignPackageDesignNotePaneLazyQueryHookResult = ReturnType<typeof useDesignPackageDesignNotePaneLazyQuery>;
export type DesignPackageDesignNotePaneSuspenseQueryHookResult = ReturnType<typeof useDesignPackageDesignNotePaneSuspenseQuery>;
export type DesignPackageDesignNotePaneQueryResult = Apollo.QueryResult<DesignPackageDesignNotePaneQuery, DesignPackageDesignNotePaneQueryVariables>;
export const DesignPackageDesignNotePane_MetadataDocument = gql`
    query DesignPackageDesignNotePane_Metadata($designPackageId: ID!, $designPackageVersionId: ID!, $targetGroupIds: [ID!]) {
  designPackage(id: $designPackageId, versionId: $designPackageVersionId) {
    id
    availableTargetGroups {
      id
      name
    }
    combinations(optionGroupIds: $targetGroupIds) {
      id
      name
      options {
        id
      }
    }
  }
}
    `;

/**
 * __useDesignPackageDesignNotePane_MetadataQuery__
 *
 * To run a query within a React component, call `useDesignPackageDesignNotePane_MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageDesignNotePane_MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageDesignNotePane_MetadataQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *      targetGroupIds: // value for 'targetGroupIds'
 *   },
 * });
 */
export function useDesignPackageDesignNotePane_MetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables> & ({ variables: DesignPackageDesignNotePane_MetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables>(DesignPackageDesignNotePane_MetadataDocument, options);
      }
export function useDesignPackageDesignNotePane_MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables>(DesignPackageDesignNotePane_MetadataDocument, options);
        }
export function useDesignPackageDesignNotePane_MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables>(DesignPackageDesignNotePane_MetadataDocument, options);
        }
export type DesignPackageDesignNotePane_MetadataQueryHookResult = ReturnType<typeof useDesignPackageDesignNotePane_MetadataQuery>;
export type DesignPackageDesignNotePane_MetadataLazyQueryHookResult = ReturnType<typeof useDesignPackageDesignNotePane_MetadataLazyQuery>;
export type DesignPackageDesignNotePane_MetadataSuspenseQueryHookResult = ReturnType<typeof useDesignPackageDesignNotePane_MetadataSuspenseQuery>;
export type DesignPackageDesignNotePane_MetadataQueryResult = Apollo.QueryResult<DesignPackageDesignNotePane_MetadataQuery, DesignPackageDesignNotePane_MetadataQueryVariables>;
export const SaveReadyPlanDesignNoteDocument = gql`
    mutation SaveReadyPlanDesignNote($input: SaveReadyPlanDesignNoteInput!) {
  saveReadyPlanDesignNote(input: $input) {
    readyPlanDesignNote {
      ...DesignPackageDesignNotePane_ReadyPlanDesignNote
    }
  }
}
    ${DesignPackageDesignNotePane_ReadyPlanDesignNoteFragmentDoc}`;
export type SaveReadyPlanDesignNoteMutationFn = Apollo.MutationFunction<SaveReadyPlanDesignNoteMutation, SaveReadyPlanDesignNoteMutationVariables>;

/**
 * __useSaveReadyPlanDesignNoteMutation__
 *
 * To run a mutation, you first call `useSaveReadyPlanDesignNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReadyPlanDesignNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReadyPlanDesignNoteMutation, { data, loading, error }] = useSaveReadyPlanDesignNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReadyPlanDesignNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveReadyPlanDesignNoteMutation, SaveReadyPlanDesignNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveReadyPlanDesignNoteMutation, SaveReadyPlanDesignNoteMutationVariables>(SaveReadyPlanDesignNoteDocument, options);
      }
export type SaveReadyPlanDesignNoteMutationHookResult = ReturnType<typeof useSaveReadyPlanDesignNoteMutation>;
export type SaveReadyPlanDesignNoteMutationResult = Apollo.MutationResult<SaveReadyPlanDesignNoteMutation>;
export type SaveReadyPlanDesignNoteMutationOptions = Apollo.BaseMutationOptions<SaveReadyPlanDesignNoteMutation, SaveReadyPlanDesignNoteMutationVariables>;